import React from 'react';
import { Box, IconButton, Modal } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useThemeContext } from '../../Context/ThemeContext';
import { DARKCOLORS, LIGHTCOLORS } from '../../Utils/constants';
import CloseIcon from "@mui/icons-material/Close";
import "../../Pages/Manage/VendingMachines/VendingMachines.css";


const ConfirmationModal = ({ open, onClose, onSave, onDiscard }) => {
    const { t } = useTranslation();
    const { mode } = useThemeContext();

    const btnColor = mode === 'dark' ? DARKCOLORS.Primary500 : LIGHTCOLORS.Primary500;

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="confirmation-modal-title"
            aria-describedby="confirmation-modal-description"
        >
            <Box className="save-sec"
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 500,
                    bgcolor: 'background.paper',
                    borderRadius: '12px',
                    boxShadow: 24,
                     p: 4
                }}
            >

                {/* Header */}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                    <h2 className='addmachine-text-heading1' style={{ margin: "0px" }}>{t('vendingMachines.saveChanges')}</h2>
                    <IconButton sx={{ p: 0 }} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <p  id="save-changes-text" className='  word-break  '>{t('vendingMachines.leavingThisPage')}</p>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '1.5rem' }}>
                    {/* Discard Button */}
                    <button type="button" style={{ color: btnColor, borderColor: btnColor }} className='cancel-btn' onClick={onDiscard}>{t('vendingMachines.discard')}</button>

                    {/* Save Button */}
                    <button type="button" onClick={onSave} style={{ background: btnColor }} className='save-btn'>{t('membershipCards.save')}</button>
                </Box>
            </Box>
        </Modal>
    );
};

export default ConfirmationModal;
